<!-- 招商引资 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-02 title="招商引资" label="INFORMARION" :showTitle="true" :showOrder="false" :showMore="false" :infoPage="infoPage" :infoBlock="infoBlock" :tabList="tabList" :tabDefaultType="tabDefaultType" count="10" v-on:queryPage="zsyz_Req"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="推荐政策" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock3" :infoPage="infoPage3" v-on:queryPage="tjzc_Req" titleLength="18" count="6"/>
        <infoList title="推荐项目" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock4" :infoPage="infoPage4" v-on:queryPage="tjxm_Req" titleLength="30" count="4"/>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import InfoPageList02 from '../block/InfoPageList02'
import InfoBlock04 from '../block/InfoBlock04'
import InfoList from '../block/InfoList'

import TitleInfoBlock01 from '../block/TitleInfoBlock01'
import TjInfo1 from '../module/TjInfo1'

export default {
  name: 'Lxwm02',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList': InfoList
  },
  data () {
    return {
      msg: '',
      infoBlock: InfoBlock04,
      infoPage: {},
      infoBlock3: TitleInfoBlock01,
      infoBlock4: TjInfo1,
      infoPage3: {},
      infoPage4: {},
      // tabList:[{title:"招商政策",type:'investment_project'},{title:"招商项目",type:'plant_technique'}],
      tabList: [{title: '招商政策', type: 'investment_policy'}, {title: '招商项目', type: 'investment_project'}],
      tabDefaultType: 'investment_project'
    }
  },
  methods: {
    // 招商引资
    zsyz_Req (params) {
      let that = this
      let result = {page: params}
      // console.log('父页面查询参数：'+JSON.stringify(params));
      that.$dataApi.articleList(params).then(res => {
        // console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg = res.msg
        result.list = res.data.list
        result.page.total = res.data.total
        that.infoPage = result
        // console.log('结束请求Vue-axios：'+JSON.stringify(result))
      })
    },
    // 推荐政策
    tjzc_Req (params) {
      let that = this
      if (this.Global.siteTabId > 0) { params.tag_id = this.Global.siteTabId }
      params.type = that.tabDefaultType
      let result = {page: params}
      console.log(params.title + '开始请求Vue-axios,参数：' + JSON.stringify(params))
      that.$dataApi.articleList(params).then(res => {
        // console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg = res.msg
        result.list = res.data.list
        result.page.total = res.data.total
        that.infoPage3 = result
        // console.log('结束请求Vue-axios：'+JSON.stringify(result))
      })
    },
    // 推荐项目
    tjxm_Req (params) {
      var date = new Date()
      let that = this
      params.queryYear = date.getFullYear()
      params.queryMonth = date.getMonth() + 1
      if (this.Global.siteTabId > 0) { params.tag_id = this.Global.siteTabId }
      let result = {page: params}
      console.log(params.title + '开始请求Vue-axios,参数：' + JSON.stringify(params))
      that.$dataApi.fastNewsLists(params).then(res => {
        // console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg = res.msg
        result.list = res.data.list
        result.page.total = res.data.total
        that.infoPage4 = result
        // console.log('结束请求Vue-axios：'+JSON.stringify(result))
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Lxwm02.vue